var render = function render(){var _vm=this,_c=_vm._self._c;return _c('contribution-event-base',{attrs:{"event":_vm.event,"variant":_vm.variant,"icon-name":"eye-slash"}},[_vm._v(_vm._s(_vm.$options.i18n.message))])
}
var staticRenderFns = []

export { render, staticRenderFns }